import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subheader-block ml-auto demo" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xl-12" }
const _hoisted_9 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_10 = {
  class: "panel-container show",
  id: "panel-editers"
}
const _hoisted_11 = { class: "panel-content contents" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "row mb-5" }
const _hoisted_18 = { class: "col-md-5 contCnt" }
const _hoisted_19 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_20 = { class: "col-md-5 contCnt" }
const _hoisted_21 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_22 = { class: "row mt-5" }
const _hoisted_23 = { class: "col-md-11 contCnt" }
const _hoisted_24 = { class: "text-success fw-500" }
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_Or_tableDailyReport = _resolveComponent("Or_tableDailyReport")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "日報入力")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.upd(false, false, false)))
            }, _cache[16] || (_cache[16] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("登録 ")
            ]), 8, _hoisted_4))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("新規登録 ")
            ]), 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.delConf()))
            }, _cache[18] || (_cache[18] = [
              _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
              _createTextVNode("削除 ")
            ]), 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "編集項目"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "日報番号", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtDailyNoFrom",
                    id: "txtDailyNoFrom",
                    class: _normalizeClass(["form-control form-control-sm", { nullUi: _ctx.isNull }]),
                    disabled: _ctx.isEditMode,
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.goEnt()), ["enter"])),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reportNumber) = $event))
                  }, null, 42, _hoisted_14), [
                    [_vModelText, _ctx.reportNumber]
                  ]),
                  _createElementVNode("input", {
                    type: "button",
                    class: "btn-primary form-control form-control-sm",
                    value: "<<",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goPrev())),
                    disabled: _ctx.inputDisable4conf
                  }, null, 8, _hoisted_15),
                  _createElementVNode("input", {
                    type: "button",
                    class: "btn-primary form-control form-control-sm",
                    value: ">>",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goNext())),
                    disabled: _ctx.inputDisable4conf
                  }, null, 8, _hoisted_16)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "記入者", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.getOpStaffs(),
                    label: "c_staff_name",
                    modelValue: _ctx.delegate.c_staff_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delegate.c_staff_id) = $event)),
                    reduce: (label) => label.c_staff_id,
                    disabled: _ctx.inputDisable4conf || _ctx.isEditMode
                  }, null, 8, ["options", "modelValue", "reduce", "disabled"]),
                  (_ctx.errors?.path === 'staffs')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "対象日", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Mt_dtp, {
                    contdate: _ctx.domReportDate,
                    "onUpdate:contdate": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.domReportDate) = $event)),
                    holidays: _ctx.delegate4list,
                    "onUpdate:holidays": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate4list) = $event)),
                    disabled: _ctx.inputDisable4conf || _ctx.isEditMode
                  }, null, 8, ["contdate", "holidays", "disabled"]),
                  (_ctx.errors?.path === 'dates')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_Or_tableDailyReport, {
                ref: "Or_tableClaim",
                items: _ctx.delegate.details,
                "onUpdate:items": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.delegate.details) = $event))
              }, null, 8, ["items"]),
              _createElementVNode("div", _hoisted_22, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "備考", -1)),
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "txtComment",
                    class: "form-control heightup",
                    placeholder: "走行距離　km",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.domRemarks) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.domRemarks]
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[12] || (_cache[12] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)),
        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => _cache[27] || (_cache[27] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[28] || (_cache[28] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => _cache[30] || (_cache[30] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[32] || (_cache[32] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}